import React from 'react';
import {Col, Flex,Image } from "antd";
import {ProductImagesProps} from "../../models";
import {StyledImage} from "./ProducImages.styled";

const ProductImages = ({imageList} : ProductImagesProps) => {
    return (
       <Flex gap={"middle"} wrap={"wrap"}>
           {imageList?.map((image, index) => (
               <Col xs={11} sm={11} md={7} lg={7} xl={7}>
                   <StyledImage
                        height={100}
                        width={100}
                       src={image}
                   />
               </Col>
           ))}
       </Flex>
    );
};

export default ProductImages;